import React from 'react';
import Navbar from 'react-bootstrap/Navbar';
import { Link } from 'react-router-dom'; 
import { HOME_PATH } from './../../config/routes'
import config from '../../config/config';
import { useResto } from '../../contexts/RestoContext';

const Logo = () => {
  const { restoData } = useResto();

  const logoUrl = (restoData && restoData.hasLogo ) 
                  ? `${config.documentsUrl}logos/logo_resized.png` 
                  : `${config.kubuniImagesUrl}mon-petit-resto/logos/logo_resized.png`;
  return (
      <Navbar.Brand>
        <p className="p-1 text-center" style={{'marginTop': '15px'}}>
          <Link to={HOME_PATH}>
            <img src={logoUrl} alt="Logo" height="140" />  
          </Link>
        </p>  
      </Navbar.Brand>
  );
}

export default Logo;
